const cleanupNumber = require('./cleanupNumber');

if(!customElements.get("finance-input-with-slider")) customElements.define("finance-input-with-slider", class extends HTMLElement {
    static get observedAttributes() {
        return ['value'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        const _this = this;
        console.log({name, oldValue, newValue, input: this});
        if (oldValue !== newValue) {
            const formattedValue = Number(newValue).toLocaleString('ru-RU');
            const input = this.firstElementChild;
            input.value = formattedValue;
        }
        if(oldValue !== newValue && _this.input) {
            const {value, caret, num} = cleanupNumber(newValue, newValue.length);
            _this.input.value = value;
            _this.input.setSelectionRange(caret, caret);
            const customEvent = new CustomEvent('change', {bubbles: true});
            customEvent.value = num;
            _this.dispatchEvent(customEvent);
            const slider = _this.querySelector('finance-input-slider');
            if(slider) {
                slider.setAttribute('value', num);
            }
        }
    }

    connectedCallback() {
        const _this = this;
        this.addEventListener('change', (e) => {
            if (e.target === this.querySelector('finance-input-slider')) {
                const val = e.value.toString();
                const {value, caret} = cleanupNumber(val, val.length);
                _this.input.value = value;
                _this.input.setSelectionRange(caret, caret);
            }
        });

        if (this.querySelector('input') === null) {
            document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded.bind(this));
        } else {
            this.onDOMContentLoaded();
        }
    }

    onDOMContentLoaded() {
        var _this = this;
        this.input = this.querySelector('input');
        this.leftPadding = this.getAttribute('input-left-padding')
        this.input.style.paddingLeft = this.leftPadding || '0';

        this.addEventListener('focus', this.onFocus.bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('blur', this.onBlur.bind(this));
        this.input.addEventListener('blur', this.onBlur.bind(this));

        this.input.addEventListener('input', function (e) {
            console.log(e);
            const {value, caret, num} = cleanupNumber(_this.input.value, _this.input.selectionStart);
            console.log({value});
            _this.input.value = value;
            _this.input.setSelectionRange(caret, caret);
            const customEvent = new CustomEvent('change', {bubbles: true});
            customEvent.value = num;
            _this.dispatchEvent(customEvent);
            const slider = _this.querySelector('finance-input-slider');
            if(slider) {
                slider.setAttribute('value', num);
            }
        });
        const {num} = cleanupNumber(this.input.value);
        const slider = _this.querySelector('finance-input-slider');
        if(slider) {
            slider.setAttribute('value', num);
        }
    }

    onBlur (e) {
        if(!this.hasAttribute('ie11-focus')) {
            this.setAttribute("focus", "false");
            for(const child of this.querySelectorAll("*")) {
                if(child.tagName !== 'INPUT') {
                    child.setAttribute("focus", "false");
                }
            }
        }
    }

    onFocus (e) {
        if(!this.hasAttribute('ie11-focus')) {
            this.setAttribute("focus", "true");
            for(const child of this.querySelectorAll("*")) {
                if(child.tagName !== 'INPUT') {
                    child.setAttribute("focus", "true");
                }
            }
        }
    }
});
